import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { fetchAuthSession } from 'aws-amplify/auth';
import {
  Box, Typography, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, Skeleton, Alert
} from '@mui/material';
import { useDeviceData } from '../../context/DeviceDataContext';
import { get_image } from '../../utils/imageUtils';

function DeviceTypeImage({ imageurl }) {
  const [src, setSrc] = useState(null);

  useEffect(() => {
    if (!imageurl) return;
    get_image(imageurl).then(result => {
      if (result?.body) {
        result.body.blob().then(blob => setSrc(URL.createObjectURL(blob)));
      }
    });
  }, [imageurl]);

  if (!src) return <Skeleton variant="rectangular" width={40} height={40} />;
  return <img src={src} alt="" style={{ height: 40, objectFit: 'contain', display: 'block' }} />;
}

export default function DeviceTypes() {
  const { t } = useTranslation();
  const [isAdmin, setIsAdmin] = useState(false);
  const [adminChecked, setAdminChecked] = useState(false);
  const { devicesData, loading } = useDeviceData();

  useEffect(() => {
    fetchAuthSession().then(session => {
      const groups = session.tokens?.idToken?.payload?.['cognito:groups'] ?? [];
      setIsAdmin(groups.includes('device_management'));
      setAdminChecked(true);
    });
  }, []);

  if (!adminChecked) return null;

  if (!isAdmin) {
    return (
      <Box>
        <Typography variant="h2" sx={{ color: 'primary.main', textAlign: 'left' }}>{t('deviceTypes.title')}</Typography>
        <Alert severity="warning" sx={{ mt: 2 }}>{t('deviceTypes.accessDenied')}</Alert>
      </Box>
    );
  }

  const deviceTypesList = devicesData?.devices?.types
    ? [...devicesData.devices.types].sort((a, b) => a.dtid - b.dtid)
    : [];

  return (
    <Box>
      <Typography variant="h2" sx={{ color: 'primary.main', textAlign: 'left' }}>{t('deviceTypes.title')}</Typography>
      <TableContainer component={Paper} variant="outlined" sx={{ mt: 2 }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={{ width: 56 }}>{t('deviceTypes.image')}</TableCell>
              <TableCell>{t('deviceTypes.name')}</TableCell>
              <TableCell>{t('deviceTypes.description')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading
              ? Array.from({ length: 5 }).map((_, i) => (
                  <TableRow key={i}>
                    <TableCell><Skeleton variant="rectangular" width={40} height={40} /></TableCell>
                    <TableCell><Skeleton /></TableCell>
                    <TableCell><Skeleton /></TableCell>
                  </TableRow>
                ))
              : deviceTypesList.map(dt => (
                  <TableRow key={dt.dtid}>
                    <TableCell><DeviceTypeImage imageurl={dt.imageurl} /></TableCell>
                    <TableCell>{dt.devicename}</TableCell>
                    <TableCell>{dt.description}</TableCell>
                  </TableRow>
                ))
            }
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
